import React, { useContext, useEffect, useState } from 'react'
import { IonContent, IonIcon, IonPage, useIonAlert, useIonToast } from '@ionic/react'
import {
  CustomSpacer,
  FooterButtons,
  PagingContent,
  StyleIonHeader,
  StyleIonInputNew,
  TextStyle,
} from '../../../components'
import styled from 'styled-components'
import { StoresContext } from '../../../provider/StoreProvider'
import { RouteComponentProps } from 'react-router'
import { checkbox, heart } from 'ionicons/icons'
import { observer } from 'mobx-react'
import { DivideLine } from '../../../components/atoms/divide'
import { VALIDATE_STATUS } from '../../../common'
import { diffHours } from '../../../common/utils/dateUtl'
import moment from 'moment'

type Props = RouteComponentProps<{
  productId: string
}>

export const ProductCommunity: React.FC<Props> = observer(({ match }) => {
  const [presentAlert] = useIonAlert()
  const [presentToast] = useIonToast()
  const { myStore } = useContext(StoresContext)
  const [validateStatus, setValidateStatus] = useState<VALIDATE_STATUS>(VALIDATE_STATUS.INPUT)
  const [inputValues, setInputValues] = useState({
    contents: '',
  })
  const { contents } = inputValues
  const pagingStore = myStore.communityPagingStore
  let loadParam = { productId: Number(match.params.productId) }

  useEffect(() => {
    loadParam = { productId: Number(match.params.productId) }
    pagingStore.load({ param: loadParam }, true)
  }, [match.params.productId])

  const onChangeInput = (event: { target: { value: string | number; name: string | number } }) => {
    const { value, name } = event.target
    setInputValues({ ...inputValues, [name]: value })
  }

  const validate = () => {
    if (contents?.length > 0) {
      setValidateStatus(VALIDATE_STATUS.OKAY)
    } else {
      setValidateStatus(VALIDATE_STATUS.INPUT)
    }
  }
  useEffect(() => {
    validate()
  }, [contents])

  const onRegisterContents = async () => {
    const ResData = await myStore.registerContents(Number(match.params.productId), contents)
    if (ResData) {
      await setTimeout(() => {
        location.reload()
      }, 100)
      return
    }
  }

  const onLikeContent = async (communityId: number) => {
    await myStore.likeContent(Number(match.params.productId), communityId)
    await pagingStore.load({ param: loadParam }, true)
  }

  const onCommunityReport = (communityId: number) => {
    presentAlert({
      mode: 'md',
      header: '정말 삭제하시겠습니까?',
      cssClass: 'custom-alert-alert ',
      buttons: [
        {
          text: '취소',
          cssClass: 'alert-button-cancel',
        },
        {
          text: '삭제하기',
          cssClass: 'alert-button-confirm',
          handler: async () => {
            const deleteResult = await myStore.deleteContent(Number(match.params.productId), communityId)
            if (!deleteResult) {
              await presentToast({
                message: '댓글을 삭제하는데 실패했습니다.',
                duration: 3000,
                position: 'top',
                color: 'danger',
                icon: checkbox,
              })
            }
            presentToast({
              message: '댓글 삭제가 완료되었습니다.',
              duration: 3000,
              position: 'top',
              color: 'primary',
              icon: checkbox,
            })
            await pagingStore.load({ param: loadParam }, true)
          },
        },
      ],
    })
  }

  return (
    <IonPage>
      <StyleIonHeader type={'SUB'} title={'작품 커뮤니티'} href={`/myPage/asset/${match.params.productId}`} />
      <IonContent>
        <PagingContent pagingStore={pagingStore} loadParam={loadParam}>
          <BannerContainer>
            <TextStyle type="r_11" color={'secondary_dark'}>
              커뮤니티는 작품에 대한 의견을 자유롭게 게세할 수 있는 공간입니다. 상업성 광고, 특정인에 대한 비방, 반복적
              게시물, 개인정보, 저속한 표현 등의 댓글은 삼가해주시길 바랍니다.
            </TextStyle>
          </BannerContainer>
          {pagingStore.list.map((d, i) => (
            <div key={i}>
              <MsgContainer>
                <TextStyle type="r_11" color="gray400">
                  {diffHours(d.createdDate) < 24 ? (
                    <>
                      {d.userName} &#183; {`${Math.floor(diffHours(d.createdDate))}시간 전`}
                      <NewBadge>N</NewBadge>
                    </>
                  ) : (
                    <>
                      {d.userName} &#183; {moment(new Date(d.createdDate)).format('MM월 DD일')}
                    </>
                  )}
                </TextStyle>
                <CustomSpacer spacing="9px" />
                <TextStyle type="r_14">{d.contents}</TextStyle>
                <CustomSpacer spacing="16px" />
                <BetweenContainer>
                  <div className="left_items" style={{ cursor: 'pointer' }} onClick={() => onLikeContent(d.id)}>
                    <IonIcon icon={heart} color={d.like ? 'danger' : 'medium'} />
                    <TextStyle type="r_14">{d.likeCount !== 0 ? d.likeCount : ''}</TextStyle>
                  </div>
                  {d.isMine ? (
                    <div className="right_items" style={{ cursor: 'pointer' }} onClick={() => onCommunityReport(d.id)}>
                      <TextStyle type="r_14" color="primary_light">
                        삭제
                      </TextStyle>
                    </div>
                  ) : (
                    <TextStyle type="r_14"></TextStyle>
                  )}
                </BetweenContainer>
              </MsgContainer>
              <DivideLine />
            </div>
          ))}
        </PagingContent>
      </IonContent>
      <footer>
        <StyleIonInputNew
          type={'text'}
          inputmode={'text'}
          inputType={'INPUT'}
          placeholder={'의견 남기기'}
          name="contents"
          onInput={onChangeInput}
        ></StyleIonInputNew>
      </footer>
      <FooterButtons
        button={{
          color: 'dark',
          text: validateStatus !== VALIDATE_STATUS.OKAY ? '내용을 입력해주세요.' : '등록',
          disabled: validateStatus !== VALIDATE_STATUS.OKAY ? true : false,
          onClick: onRegisterContents,
        }}
      />
    </IonPage>
  )
})

const MsgContainer = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
`

const BetweenContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  .left_items {
    display: flex;
    align-items: center;
    ion-icon {
      width: 20px;
      height: 20px;
      margin-right: 5px;
    }
  }
  .right_items {
    display: flex;
    align-items: center;
  }
`

const BannerContainer = styled.div`
  margin: 20px 20px 0px;
  padding: 8px 10px;
  border-radius: 8px;
  background-color: var(--ion-color-secondary_light);
`

const NewBadge = styled.span`
  padding: 0px 5px 2px;
  border-radius: 15px;
  background-color: var(--ion-color-success_light);
  margin-left: 4px;
  font-size: 8px;
  font-weight: 700;
  color: var(--ion-color-secondary_main);
`
